import { AdObject } from './types';

/**
 * A Store for AdObjects in an AdBundle
 */
export class AdBundle {
    #ads: AdObject[];
    #id: number;

    constructor(id: number) {
        this.#id = id;
        this.#ads = [];
    }

    public get id(): number {
        return this.#id;
    }

    public get ads(): AdObject[] {
        return this.#ads;
    }

    /**
     * Returns next AdObject with the lowest playcount
     */
    public next(): AdObject {
        if (this.#ads.length === 0) {
            throw new Error('No ads in bundle');
        }

        let lowestPlayCount = this.#ads[0].playcount;
        let nextAd: AdObject = this.#ads[0];

        for (let x = 0; x < this.#ads.length; x++) {
            const playCount = this.#ads[x].playcount;
            if (playCount < lowestPlayCount) {
                lowestPlayCount = playCount;
                nextAd = this.#ads[x];
            }
        }

        return nextAd;
    }

    /**
     * Remove ad from bundle
     */
    public removeAds(ids: number[]): void {
        this.#ads = this.#ads.filter((ad: AdObject) => {
            return !ids.includes(ad.adid);
        });
    }
}
